import { patchCustomElements } from "./utils/custom-elements";
import "./interceptors";

patchCustomElements();
